<template>
  <div>
    <vue-headful title="Bewerk profiel" />
    <Header page_title="Bewerk profiel" />
    <div class="sd-menu app-body">
      <div class="organisation-container">
        <span class="container-fluid sd-title small menu-title">
            <svg-icon icon="education" />
            <span class="menu-title-text">Organisatie</span>
        </span>
        <ul class="menu">
          <li class="menu-item personal-details">
            <router-link :to="{name: 'company-profile'}" class="container-fluid">
              <svg-icon v-if="!user.avatar" icon="person_male" class="profile-img" />
              <span v-else :style="user ? this.ImageBackground($store.state.user_avatar):''" class="profile-img"></span>
              <div class="user-container">
                <span class="user-name sd-title bold">{{ user.name }}</span>
                <span class="user-desc">Jouw organisatie bekijken</span>
              </div>
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
            <li class="menu-item">
              <router-link :to="{ name: 'company-details', params: { action: 'save' } }" class="container-fluid" >
                Organisatiegegevens
                <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link :to="{ name: 'company-details', params: { action: 'save' } }" class="container-fluid" >
                Contactpersoon
                <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link :to="{ name: 'company-step_1', params: { action: 'save' } }" class="container-fluid" >
                Logo aanpassen
                <svg-icon icon="chevron_e" class="menu-item-icon"/>
              </router-link>
            </li>
          </li>
        </ul>
      </div>
      <div class="location-container">
       <span class="container-fluid sd-title small menu-title">
          <svg-icon icon="marker" />
          <span class="menu-title-text">Locaties</span>
        </span>
        <ul class="menu">
          <li class="menu-item">
            <router-link :to="{ name: 'company-details', params: { action: 'save' } }" class="container-fluid" >
              Adresgegevens
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'location-add', params: { action: 'save' } }" class="container-fluid" >
              Locatie toevoegen
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
          <li class="menu-item"></li>
        </ul>
      </div>
      <div class="settings-container">
         <span class="container-fluid sd-title small menu-title">
            <svg-icon icon="education" />
            <span class="menu-title-text">Jouw gegevens</span>
        </span>
        <ul class="menu">
          <li class="menu-item">
            <router-link :to="{ name: 'notifications', params: { action: 'save' } }" class="container-fluid" >
              Notificaties
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'update-password' }" class="container-fluid">
              Wachtwoord wijzigen
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'delete', params: { action: 'save' } }" class="container-fluid">
              Account verwijderen
              <svg-icon icon="chevron_e" class="menu-item-icon"/>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!--<div class="px-4 mx-2 pb-3">
      <div class="container-fluid p-0 pb-3">
        <div class="mb-4 pb-3 component">
          <router-link
            :to="{ name: 'company-details', params: { action: 'save' } }"
            class="d-block text-derect"
          >
            <div class="profile-edit card border-0 bg-gray">
              <div class="card-body position-relative">
                <div class="d-flex align-items-center">
                  <div class="icon">
                    <svg
                      version="1.1"
                      viewBox="0 0 73 73"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <path
                          d="m36.5 0c-20.11 0-36.5 16.39-36.5 36.5s16.39 36.5 36.5 36.5 36.5-16.39 36.5-36.5-16.39-36.5-36.5-36.5zm0 66.49c-16.506 0-29.99-13.484-29.99-29.99s13.484-29.99 29.99-29.99 29.99 13.484 29.99 29.99-13.484 29.99-29.99 29.99z"
                          fill="#DCDBDB"
                          fill-rule="nonzero"
                        />
                        <g transform="translate(15 15)">
                          <polygon points="0 0 43 0 43 43 0 43" />
                          <circle
                            cx="21.5"
                            cy="21.5"
                            r="5.375"
                            fill="#DCDBDB"
                          />
                          <path
                            d="m35.833 7.1667h-5.6796l-2.2217-2.4188c-0.66292-0.73458-1.6304-1.1646-2.6338-1.1646h-7.5967c-1.0033 0-1.9708 0.43-2.6517 1.1646l-2.2038 2.4188h-5.6796c-1.9708 0-3.5833 1.6125-3.5833 3.5833v21.5c0 1.9708 1.6125 3.5833 3.5833 3.5833h28.667c1.9708 0 3.5833-1.6125 3.5833-3.5833v-21.5c0-1.9708-1.6125-3.5833-3.5833-3.5833zm-14.333 23.292c-4.945 0-8.9583-4.0133-8.9583-8.9583s4.0133-8.9583 8.9583-8.9583 8.9583 4.0133 8.9583 8.9583-4.0133 8.9583-8.9583 8.9583z"
                            fill="#DCDBDB"
                            fill-rule="nonzero"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="mb-0">
                    <strong>Accountgegevens</strong>
                  </p>
                </div>
                <div class="arrow position-absolute d-block h-100">
                  <span class="icon-wrapper position-absolute">
                    <i class="material-icons-round">arrow_forward_ios</i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <router-link
            :to="{ name: 'company-step_1', params: { action: 'save' } }"
            class="d-block text-derect"
          >
            <div class="profile-edit card border-0 bg-gray">
              <div class="card-body position-relative">
                <div class="d-flex align-items-center">
                  <div class="icon">
                    <svg
                      version="1.1"
                      viewBox="0 0 73 73"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fill="none" fill-rule="evenodd">
                        <g fill="#DCDBDB" fill-rule="nonzero">
                          <path
                            d="m36.5 0c-20.11 0-36.5 16.39-36.5 36.5s16.39 36.5 36.5 36.5 36.5-16.39 36.5-36.5-16.39-36.5-36.5-36.5zm0 66.49c-16.506 0-29.99-13.484-29.99-29.99s13.484-29.99 29.99-29.99 29.99 13.484 29.99 29.99-13.484 29.99-29.99 29.99z"
                          />
                          <g transform="translate(24 19)">
                            <path
                              d="m21.747 0h-18.495c-1.7776 0-3.2526 1.5081-3.2526 3.3255v29.349c0 1.8174 1.475 3.3255 3.2526 3.3255h18.495c1.7776 0 3.2526-1.5081 3.2526-3.3255v-29.349c0-1.8174-1.475-3.3255-3.2526-3.3255zm-9.2663 5.6842c1.3994 0 2.4962 1.16 2.4962 2.5521s-1.1346 2.5521-2.4962 2.5521c-1.3616 0-2.4962-1.16-2.4962-2.5521s1.1346-2.5521 2.4962-2.5521zm-3.2905 8.855c0-0.88937 1.475-2.5908 3.2905-2.5908 1.8154 0 3.2905 1.7014 3.2905 2.5908v1.16c0 2.4361-0.34039 2.7068-1.7776 2.7068h-3.0257c-1.475 0-1.7776-0.27068-1.7776-2.7068v-1.16zm10.703 15.235h-14.788c-0.5295 0-0.90772-0.38668-0.90772-0.92803s0.41604-0.92803 0.90772-0.92803h14.826c0.49168 0 0.90772 0.42535 0.90772 0.92803s-0.45386 0.92803-0.94554 0.92803zm0-4.7175h-14.788c-0.49168 0-0.90772-0.42535-0.90772-0.92803 0-0.50269 0.37821-0.92803 0.90772-0.92803h14.826c0.49168 0 0.90772 0.42535 0.90772 0.92803 0 0.50269-0.45386 0.92803-0.94554 0.92803z"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <p class="mb-0">
                    <strong>Profiel</strong>
                  </p>
                </div>
                <div class="arrow position-absolute d-block h-100">
                  <span class="icon-wrapper position-absolute">
                    <i class="material-icons-round">arrow_forward_ios</i>
                  </span>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <router-link
          :to="{ name: 'company-dashboard' }"
          title="Naar mijn Dashboard"
          class="btn btn-warning btn-block text-derect"
          v-ripple="'rgba(255, 255, 255, 0.35)'"
          >Naar mijn Dashboard</router-link
        >
      </div>
    </div>-->
    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      branch: null,
      isZzp: false,
      logged_in: this.isUserActiveLoggedIn(),
      route: window.location.href,
      user_token: '',
      user: ''
    };
  },
  async created() {
  },
  watch: {
    navState: async function() {
      await this.fetchData();
    },
    $route: "fetchData"
  },
  async mounted() {
    this.fetchData();
  },
  methods: {
    gotoDashboard() {
      const user = JSON.parse(localStorage.getItem("user"));
      if(user) {
        if(user.type == 1) {
          this.$router.replace({
            name: "applicant-dashboard"
          }).catch(() => {});
        } else {
          this.$router.replace({
            name: "company-dashboard"
          }).catch(() => {});
        }
      } else {
        this.$router.replace({
          name: "login"
        });
      }
    },
    async fetchData() {
      this.branch = localStorage.getItem("branch");
      this.user_token = JSON.parse(localStorage.getItem("user-token"));
      this.user = JSON.parse(localStorage.getItem("user"));

      if(user.customer_type == 1)
        this.isZzp = true;

      if(this.user_token == null)
        this.user_token = "";

      if(this.user == null)
        this.user = "";

      if(this.user)
        this.$store.state.user_avatar = this.user.avatar;
    }
  }
}
</script>

<style scoped>
.sd-menu {
  position: relative;
  margin-bottom: 40px;
}

.sd-title.menu-title {
  display: flex;
  align-items: center;
  margin-top: 40px !important;
  margin-bottom: 20px !important;
  padding: 0 20px;
  line-height: 1;
}

.sd-title.menu-title .menu-title-text {
  margin-top: 3px;
  line-height: 1;
}

/deep/ .sd-title.menu-title svg {
  margin-right: 20px;
  height: 20px;
  width: 20px;
  color: #FFCD00;
}

.menu {
  list-style: none;
  padding-left: 0;
}

.menu .menu-item {
  border-bottom: 1px solid #F4F4F4;
}

.menu .menu-item a {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #64513D;
  justify-content: space-between;
  padding: 20px;
}

/deep/ .menu .menu-item a .menu-item-icon svg {
  height: 12px;
}

.menu .menu-item.personal-details {
  padding-top: 0;
  padding-bottom: 10px;
  border-bottom: 0;
}

.menu .menu-item.personal-details a {
  display: block;
  border: 1px solid #F4F4F4;
  padding: 10px 20px;
  border-radius: 10px;
}

.menu .menu-item.personal-details a {
  display: grid;
  align-items: center;
  grid-template-columns: 40px 1fr 10px;
}

.menu .menu-item.personal-details .profile-img {
  display: block;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-size: cover;
}

.menu .menu-item.personal-details .user-name {
  display: block;
  font-size: 14px;
}

.menu .menu-item.personal-details .user-desc {
  display: block;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .sd-title.menu-title {
    padding: 0 20px;
  }
}
</style>
